module.exports = __webpack_public_path__ + "media/images/athletes/3566-c6bd0e2cf624038b4258e7599424bed1.png";